import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from 'libs/axios/axios';

const editOperationDetail = async (values: { targetId: number; inputValue: string }) => {
  const { targetId, inputValue } = values;

  const { data } = await axiosClient.patch(`/operation/detail/${targetId}`, {
    explanation: inputValue,
  });

  return data;
};

const useEditOperationDetailQuery = () => {
  const queryClient = useQueryClient();

  return useMutation(['operationDetail', 'edit'], editOperationDetail, {
    onSuccess: () => {
      queryClient.invalidateQueries(['operationDetail', 'list']);
    },
    onError: (error) => {
      alert('수정 실패. 다시 한 번 시도해주세요');
      console.error('edit operation detail error', error);
    },
  });
};

export default useEditOperationDetailQuery;
